var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import i18n from 'i18next';
import UserTypes from '../action-types/user';
import firebase from '../firebase';
import { users } from '../services/api/ava';
import { users as saasUsers } from '../services/api/saas';
export const updateUserFeaturesRequest = () => ({
    type: UserTypes.UPDATE_USER_FEATURES_REQUEST,
});
export const updateUserFeaturesSuccess = ({ features }) => ({
    type: UserTypes.UPDATE_USER_FEATURES_SUCCESS,
    payload: features,
});
export const updateUserFeaturesFailure = (errorMessage) => ({
    type: UserTypes.UPDATE_USER_FEATURES_FAILURE,
    payload: errorMessage,
});
export const updateUserFeaturesRequestAsync = ({ avaId, features }) => {
    return (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
        dispatch(updateUserFeaturesRequest());
        try {
            const firebaseUser = firebase.auth().currentUser;
            if (!firebaseUser)
                return;
            yield users.updateFeatures({ avaId, firebaseAuthUID: firebaseUser.uid, features });
            dispatch(updateUserFeaturesSuccess({ features }));
        }
        catch (err) {
            dispatch(updateUserFeaturesFailure(err.message));
        }
    });
};
export const updateUserHearingProfileRequest = () => ({
    type: UserTypes.UPDATE_USER_HEARING_PROFILE_REQUEST,
});
export const updateUserHearingProfileSuccess = (hearingProfile) => ({
    type: UserTypes.UPDATE_USER_HEARING_PROFILE_SUCCESS,
    payload: hearingProfile,
});
export const updateUserHearingProfileFailure = (errorMessage) => ({
    type: UserTypes.UPDATE_USER_HEARING_PROFILE_FAILURE,
    payload: errorMessage,
});
export const updateUserHearingProfileRequestAsync = (hearingProfile) => {
    return (dispatch, getState) => __awaiter(void 0, void 0, void 0, function* () {
        dispatch(updateUserHearingProfileRequest());
        const { scribeSession: { captioner: { avaId, firebaseAuthUID }, }, } = getState();
        try {
            yield users.updateHearingProfile({ avaId, firebaseAuthUID, hearingProfile });
            dispatch(updateUserHearingProfileSuccess(hearingProfile));
        }
        catch (err) {
            dispatch(updateUserHearingProfileFailure(err.message));
        }
    });
};
export const updateUserNameRequest = () => ({
    type: UserTypes.UPDATE_USER_NAME_REQUEST,
});
export const updateUserNameSuccess = (userName) => ({
    type: UserTypes.UPDATE_USER_NAME_SUCCESS,
    payload: userName,
});
export const updateUserNameFailure = (errorMessage) => ({
    type: UserTypes.UPDATE_USER_NAME_FAILURE,
    payload: errorMessage,
});
export const updateUserNameRequestAsync = (userName) => {
    return (dispatch, getState) => __awaiter(void 0, void 0, void 0, function* () {
        dispatch(updateUserNameRequest());
        const { scribeSession: { captioner: { avaId, firebaseAuthUID }, }, } = getState();
        try {
            yield users.updateUserName({ avaId, firebaseAuthUID, userName });
            dispatch(updateUserNameSuccess(userName));
        }
        catch (err) {
            dispatch(updateUserNameFailure(err.message));
        }
    });
};
export const setUpdateUserNameSuccess = (value) => ({
    type: UserTypes.SET_UPDATE_USER_NAME_SUCCESS,
    payload: value,
});
export const setUserOrganization = (org) => ({
    type: UserTypes.SET_ORGANIZATION,
    payload: org,
});
export const getUserOrganization = () => {
    return (dispatch, getState) => __awaiter(void 0, void 0, void 0, function* () {
        let org = null;
        try {
            const { language } = i18n;
            const res = yield saasUsers.getUser(language);
            org = res.data.organization;
        }
        catch (e) { }
        dispatch(setUserOrganization(org));
    });
};
